import { render, staticRenderFns } from "./ResponsabilityBox.vue?vue&type=template&id=4260b6c4&"
import script from "./ResponsabilityBox.vue?vue&type=script&lang=js&"
export * from "./ResponsabilityBox.vue?vue&type=script&lang=js&"
import style0 from "./ResponsabilityBox.vue?vue&type=style&index=0&id=4260b6c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports